import { render, staticRenderFns } from "./modalDegustacao.vue?vue&type=template&id=a69eed5a&scoped=true&"
import script from "./modalDegustacao.vue?vue&type=script&lang=js&"
export * from "./modalDegustacao.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=a69eed5a&scoped=true&lang=css&"
import style1 from "./modalDegustacao.vue?vue&type=style&index=1&id=a69eed5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69eed5a",
  null
  
)

export default component.exports